/**
 * Fetch ad
 * Viewloader compatible function
 * @param  {Node} el DOM node the function is bound to
 * @return {Void}
 */

type Props = {
  contentType: string,
  label: string,
  pagePath: string,
  size: string,
};

type AdResponse = {
  image_url: string,
  target_url: string,
  campaign_name: string,
}

export default async function fetchAd(el: HTMLElement, props: Props) {
  const advertisementWrapper = el.querySelector(".advertisement");
  const advertisementBox = el.querySelector(".advertisement__box");
  if (!advertisementWrapper || !advertisementBox) {
    return;
  }

  const params = new URLSearchParams();
  params.append("content_type", props.contentType);
  params.append("page_path", props.pagePath);
  params.append("size", props.size);

  const response = await fetch(`/ads.json?${params}`, {
    method: "GET",
    credentials: "same-origin",
    headers: {
      accept: "application/json"
    }
  });

  // A 204 status code is returned if no ad is found
  if (response.status !== 200) {
    advertisementWrapper.parentNode?.removeChild(advertisementWrapper);
    return;
  }

  const ad: AdResponse = await response.json();

  const a = document.createElement("a");
  a.href = ad.target_url;
  a.target = "_blank";
  a.rel = "noopener";
  a.setAttribute("ga-on", "click,auxclick,contextmenu");
  a.setAttribute("ga-event-category", "ad");
  a.setAttribute("ga-event-action", "click");
  a.setAttribute("ga-event-label", `${props.label} - ${ad.campaign_name}`);

  const img = document.createElement("img");
  img.src = ad.image_url;
  a.appendChild(img);

  advertisementBox.replaceChildren(a);

  // Remove the hidden class from advertisementWrapper to expose the ad
  advertisementWrapper.classList.remove("advertisement--hidden");
}
